import React, { useEffect, useState } from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { HeadingType } from '../heading/heading-constants.js';
import { useHeading } from '../heading-context/heading-context.js';
import './heading-title.css';
const tags = {
    [HeadingType.CONTEXTUAL_BAR]: 'h2',
    [HeadingType.SECTION]: 'h3',
    [HeadingType.SUBSECTION]: 'h4',
};
function HeadingTitle() {
    const context = useHeading();
    const [title, setTitle] = useState(context.getTitle());
    const Tag = tags[context.getType()];
    useEffect(() => {
        const unlisten = context?.addTitleListener(() => {
            setTitle(context.getTitle());
        });
        setTitle(context.getTitle());
        return () => {
            if (!isFunction(unlisten)) {
                return;
            }
            unlisten();
        };
    }, []);
    return (React.createElement(Tag, { className: "c-heading__title u-hide@empty", id: `${context.getIdentifier()}-heading__title` }, MessageService.translate(title ?? '')));
}
export { HeadingTitle, };
//# sourceMappingURL=heading-title.js.map